export default {
  path: '/tool_heaters',
  name: 'tool_heaters',
  component: () => import('../components/toolheater/Layout'),
  redirect: { name: 'ToolHeaterList' },
  meta: {
    breadcrumb: 'profile.tool.heaters',
  },
  children: [
    {
      name: 'ToolHeaterList',
      path: '',
      component: () => import('../views/toolheater/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ToolHeaterCreate',
      path: 'new',
      component: () => import('../views/toolheater/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ToolHeaterUpdate',
      path: ':id/edit',
      component: () => import('../views/toolheater/Update'),
      meta: {
        breadcrumb: 'profile.tool.heater',
      },
    },
    {
      name: 'ToolHeaterShow',
      path: ':id',
      component: () => import('../views/toolheater/Show'),
      meta: {
        breadcrumb: 'profile.tool.heater',
      },
    }
  ]
};
